import { types } from "@proj/static";
import http from "../utils/http";

export const getStates = async () => {
    let result = await (await http().get(`/state`)).data;
    return result.data;
}